(() => {
  const SELECTOR_MODAL =
    '[data-uc-modal="comparison"], section.uc-sec.sec-comparison[id^="sec-comparison-"]';

  const run = () => {
    const modal = document.querySelector(SELECTOR_MODAL);
    if (!modal) return;

    const card = modal.querySelector('.up-wrapper');

    const openModal = (e) => {
      e?.preventDefault?.();
      modal.classList.add('target');
    };

    const closeModal = (e) => {
      e?.preventDefault?.();
      modal.classList.remove('target');
    };

    // Help links (idempotent)
    document.querySelectorAll('.product-options__option-title').forEach((title) => {
      if (title.textContent?.trim() && !title.querySelector('.uc-help-link')) {
        const helpLink = document.createElement('a');
        helpLink.href = '#';
        helpLink.textContent = '(Help me choose)';
        helpLink.className = 'btn--link uc-help-link';
        helpLink.style.margin = '1rem 0.25rem';
        helpLink.style.display = 'inline';
        helpLink.style.padding = '0';
        helpLink.style.pointerEvents = 'initial';
        helpLink.style.color = '#3f858e';
        helpLink.addEventListener('click', openModal);
        title.appendChild(helpLink);
      }
    });

    // Close button
    const closeBtn = modal.querySelector('.uc-close');
    if (closeBtn && !closeBtn.dataset.ucWired) {
      closeBtn.addEventListener('click', closeModal);
      closeBtn.dataset.ucWired = '1';
    }

    // Click outside (backdrop) closes
    if (!modal.dataset.ucBackdropWired) {
      modal.addEventListener('click', (e) => {
        if (!card || !card.contains(e.target)) closeModal();
      });
      modal.dataset.ucBackdropWired = '1';
    }

    // Escape closes
    if (!modal.dataset.ucEscWired) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('target')) closeModal();
      });
      modal.dataset.ucEscWired = '1';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
